export default __webpack_public_path__ + "static/media/title_my_order.c37392c6.svg";